import { Link } from "react-router-dom"
import paths from "../../../constants/paths"

export default function CompanyHiring({heading,
	tagline,
	btn1_txt,
	btn2_txt}) {
	return (
		<>
			<div className="hiring_block">
				<div className="text text-center">
					<div className="h2">{heading}</div>
					<p>
						{tagline}
					</p>
					<div className="btn_blk justify-content-center">
						<Link to={paths.PUBLIC_SITE_URL+"about"} className="site_btn simple">
							{btn1_txt}
							{/* <img src="images/icon_arrow_right_color.png" alt="" /> */}
						</Link>
						<Link to={paths.PUBLIC_SITE_URL+"faq"} className="site_btn blank">
							{btn2_txt}
						</Link>
					</div>
				</div>
			</div>
		</>
	)
}
